<template>
  <div class="my-0 py-0 px-2 mx-3">
    <v-container grid-list-xs fluid my-0 px-0 py-2>
      <v-layout row wrap mx-2 py-0 my-0>
        <v-flex xs12>
          <v-divider class="mx-0 mt-0 py-0 mb-1 grey"></v-divider>
        </v-flex>
        <!-- <v-flex xs12> -->
        <v-flex
          @click="show = 'facts'"
          style="cursor: pointer"
          xs4
          :class="{
            underline: show != 'facts',
            'menu mx-0 mb-1 display-1 px-2 pt-1': true,
          }"
        >
          Facts and Figures
        </v-flex>
        <v-flex
          @click="show = 'info'"
          style="cursor: pointer"
          xs4
          :class="{
            underline: show != 'info',
            'menu mx-0 mb-1 display-1 px-2 pt-1': true,
          }"
        >
          System Info</v-flex
        >
        <v-spacer></v-spacer>
        <v-flex xs12>
          <v-divider class="mx-0 my-0 py-0 grey"></v-divider>
        </v-flex>
        <!-- </v-flex> -->

        <v-flex v-if="show == 'facts'" xs12 lg4 md6 mb-4 mt-5>
          <v-flex xs12 mb-4>
            <div class="display-1">Artworks over years 1950-2020</div>
          </v-flex>
          <v-flex xs12 mb-4>
            <v-sparkline
              line-width="2"
              padding="4"
              smooth="3"
              :value="value_artworks"
              auto-draw
            >
              <!-- :labels="years_artworks" -->
              <!-- <template v-slot:label="item">
                {{ item.value }}
              </template> -->
            </v-sparkline>
          </v-flex>

          <v-flex xs12 mb-4>
            <div class="display-1">
              <span class="value"
                >{{ this.$store.getters.collection.length }}
              </span>
              Artworks in total
            </div>
          </v-flex>

          <v-flex xs12>
            <v-card class="elevation-0 px-2">
              <a
                class="display-1"
                @click="$router.push({ path: '/artworks/filter/paintings' })"
              >
                <span class="value">
                  {{ this.$store.getters.paintings.length }}
                </span>
                Paintings
              </a>
            </v-card>
          </v-flex>

          <v-flex xs12>
            <v-card class="elevation-0 px-2">
              <a
                class="display-1"
                @click="$router.push({ path: '/artworks/filter/drawings' })"
              >
                <span class="value">
                  {{ this.$store.getters.drawings.length }}
                </span>
                Drawings
              </a>
            </v-card>
          </v-flex>

          <v-flex xs12>
            <v-card class="elevation-0 px-2">
              <a
                class="display-1"
                @click="$router.push({ path: '/artworks/filter/photographs' })"
              >
                <span class="value">{{
                  this.$store.getters.photographs.length
                }}</span>
                Photos | Prints | Collages
              </a>
            </v-card>
          </v-flex>

          <v-flex xs12>
            <v-card class="elevation-0 px-2">
              <a
                class="display-1"
                @click="$router.push({ path: '/artworks/filter/videos' })"
              >
                <span class="value">{{
                  this.$store.getters.videos.length
                }}</span>
                Video Installations
              </a>
            </v-card>
          </v-flex>

          <v-flex xs12>
            <v-card class="elevation-0 px-2">
              <a
                class="display-1"
                @click="$router.push({ path: '/artworks/filter/sound' })"
              >
                <span class="value">{{
                  this.$store.getters.sound.length
                }}</span>
                Sound Installations
              </a>
            </v-card>
          </v-flex>

          <v-flex xs12>
            <v-card class="elevation-0 px-2">
              <a
                class="display-1"
                @click="
                  $router.push({
                    path: '/artworks/filter/objectsAndSculptures',
                  })
                "
              >
                <span class="value">{{
                  this.$store.getters.objectsAndSculptures.length
                }}</span>
                Objects | Sculptures
              </a>
            </v-card>
          </v-flex>
          <!-- <v-flex xs12>
            <v-card class="elevation-0 px-2">
              <div class="display-1"><span class="value">{{ this.$store.getters.sculptures.length }}</span> Sculptures</div>
            </v-card>
          </v-flex> -->
        </v-flex>

        <v-flex v-if="show == 'facts'" xs12 lg4 md6 mb-4 mt-5>
          <v-flex xs12 mb-4>
            <v-card class="elevation-0 px-2">
              <div class="display-1">
                <span class="value">{{
                  this.$store.state.artists.length
                }}</span>
                Artists in total
              </div>
            </v-card>
          </v-flex>
          <v-flex xs12>
            <v-card class="elevation-0 px-2">
              <div class="display-1">
                <span class="value">{{
                  this.$store.getters.artistsYoung.length
                }}</span>
                under 30 years old
              </div>
            </v-card>
          </v-flex>
          <v-flex xs12>
            <v-card class="elevation-0 px-2">
              <div class="display-1">
                <span class="value">{{
                  this.$store.getters.artistsMid.length
                }}</span>
                30 to 50 years old
              </div>
            </v-card>
          </v-flex>
          <v-flex xs12>
            <v-card class="elevation-0 px-2">
              <div class="display-1">
                <span class="value">{{
                  this.$store.getters.artistsOld.length
                }}</span>
                over 50 years old
              </div>
            </v-card>
          </v-flex>
        </v-flex>

        <v-flex v-if="show == 'facts'" xs12 lg4 md6 mb-4 mt-5>
          <v-flex xs12 mb-4>
            <div class="display-1">Exhibitions over years 2000-2020</div>
          </v-flex>
          <v-flex xs12 mb-4>
            <v-sparkline
              line-width="2"
              padding="4"
              smooth="3"
              :value="value_exhibitions"
              :labels="years"
              auto-draw
            >
              <template v-slot:label="item">
                {{ item.value }}
              </template>
            </v-sparkline>
          </v-flex>

          <v-flex xs12 mb-4>
            <v-card class="elevation-0 px-2">
              <div class="display-1">
                <span class="value">{{
                  this.$store.getters.exhibitions.length
                }}</span>
                Exhibitions in total
              </div>
            </v-card>
          </v-flex>
          <!-- <v-flex xs12>
            <v-card class="elevation-0 px-2">
              <div class="display-1"><span class="value">{{ this.$store.state.exhibitions.length }}</span> XX in Europe</div>
            </v-card>
          </v-flex>
          <v-flex xs12>
            <v-card class="elevation-0 px-2">
              <div class="display-1"><span class="value">{{ this.$store.state.exhibitions.length }}</span> XX  in North America</div>
            </v-card>
          </v-flex>
          <v-flex xs12>
            <v-card class="elevation-0 px-2">
              <div class="display-1"><span class="value">{{ this.$store.state.exhibitions.length }}</span> XX  in South America</div>
            </v-card>
          </v-flex>
          <v-flex xs12 mb-3>
            <v-card class="elevation-0 px-2">
              <div class="display-1"><span class="value">{{ this.$store.state.exhibitions.length }}</span> XX  in Asia</div>
            </v-card>
          </v-flex> -->

          <v-flex
            xs12
            v-for="y in [2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012]"
            :key="y"
          >
            <v-card class="elevation-0 px-2">
              <div class="display-1">
                <span class="value">{{ exhibitionsInYear(y).length }}</span> in
                {{ y }}
              </div>
            </v-card>
          </v-flex>
        </v-flex>

        <v-flex v-if="show == 'facts'" xs12 lg4 md6 mb-4 mt-5>
          <v-flex xs12 mb-4>
            <div class="display-1">Loans over years 2000-2020</div>
          </v-flex>
          <v-flex xs12 mb-4>
            <v-sparkline
              line-width="2"
              padding="4"
              smooth="3"
              :value="value_loans"
              :labels="years"
              auto-draw
            >
              <template v-slot:label="item">
                {{ item.value }}
              </template>
            </v-sparkline>
          </v-flex>

          <v-flex xs12 mb-4>
            <v-card class="elevation-0 px-2">
              <div class="display-1">
                <span class="value">{{
                  this.$store.getters.loans.length
                }}</span>
                Loans in total
              </div>
            </v-card>
          </v-flex>

          <v-flex
            xs12
            v-for="y in [2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012]"
            :key="y"
          >
            <v-card class="elevation-0 px-2">
              <div class="display-1">
                <span class="value">{{ loansInYear(y).length }}</span> in
                {{ y }}
              </div>
            </v-card>
          </v-flex>
        </v-flex>

        <v-flex v-if="show == 'info'" xs12 lg6 mb-2 mt-5>
          <v-flex xs12 mb-4>
            <div class="display-1 mb-4 mx-1">CMS Updates</div>
            <v-card
              style="border-bottom: solid 1px #ddd"
              :class="{ atWork: sa.at_work }"
              outlined
              loading
              class="elevation-0 mb-3"
              v-for="sa in support_articles"
              :key="'sa_' + sa.id"
            >
              <v-progress-linear
                height="2"
                indeterminate
                v-if="sa.at_work"
              ></v-progress-linear>
              <v-card-title class="title px-2 py-0">
                <v-flex>{{ sa.version }} | {{ sa.title }}</v-flex>
                <v-spacer></v-spacer>
                <v-flex class="body-1 text-xs-right">
                  {{ sa.publish_date }}
                </v-flex>
              </v-card-title>
              <!-- <v-card-title class="sub-header px-3"> {{ sa.title }} </v-card-title> -->
              <!-- <v-card-text class="subtitle-2 mb-2"></v-card-text> -->
              <v-card-text>
                <div v-html="sa.body" class="body-1"></div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-flex>

        <v-flex v-if="show == 'info'" xs12 lg6 mb-4 mt-5>
          <v-flex xs12 mb-4>
            <v-flex style="margin-bottom: 17px" class="display-1 mx-3 xs12">
              User Activity
              <!-- <v-spacer></v-spacer> -->
              <v-switch
                class="right"
                label="Only my activity"
                v-model="myJournal"
                color="black"
              ></v-switch>
            </v-flex>
            <v-card
              v-for="(item, index) in journals.slice(0, 30)"
              :key="'j_' + item.id"
              class="ml-3 py-2 elevation-0 pt-3"
              style="border-top: 1px solid #ddd"
              v-if="journals.length > 0"
            >
              <v-card-title class="title px-3 py-0">
                <v-flex
                  >{{ format_date(item.created_at) }} |
                  {{ item.value_name }} changed</v-flex
                >
                <v-spacer></v-spacer>
                <v-flex class="body-1 text-xs-right">
                  <v-list-tile-action-text>
                    In {{ item.cms }} CMS by
                    {{ format_journal_user(item) }}</v-list-tile-action-text
                  >
                  <v-icon
                    v-if="item.user_id != c_user.id"
                    color="grey lighten-1"
                  >
                    star_border
                  </v-icon>
                  <v-icon v-else color="yellow darken-2"> star </v-icon>
                </v-flex>
              </v-card-title>
              <v-card-text>
                <div v-html="format_journal_artwork(item)" class="body-1"></div>
                <div
                  v-html="
                    '<b>OLD VALUE:</b> ' +
                    (item.old_value == null ? '' : item.old_value)
                  "
                  class="body-1 my-2"
                ></div>
                <div
                  v-html="'<b>NEW VALUE:</b> ' + item.new_value"
                  class="body-1"
                ></div>
              </v-card-text>
            </v-card>

            <!-- <v-list-tile-title>{{ format_date(item.created_at) }} </v-list-tile-title> -->
            <!-- <v-list-tile-title v-html="format_journal_artwork(item)" class="text--primary"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="format_journal_journal(item)"></v-list-tile-sub-title>
                  </v-list-tile-content> -->

            <!-- <v-list-tile-action>
                    <v-list-tile-action-text> In {{item.cms}} CMS by {{format_journal_user(item)}}</v-list-tile-action-text>
                    <v-icon v-if="item.user_id != c_user.id" color="grey lighten-1"> star_border </v-icon>
                    <v-icon v-else color="yellow darken-2" > star </v-icon>
                  </v-list-tile-action>
                </v-list-tile> -->
            <!-- <v-divider v-if="index + 1 < journals.length" :key="index" ></v-divider> -->
            <!-- </template>
            </v-list> -->

            <div v-if="!journals.length > 0" class="subheading mt-4 ml-4">
              No updates recorded for this user.
            </div>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      myJournal: false,
      show: 'facts',
      journals_store: this.$store.state.journals,
      sa_store: this.$store.state.support_articles,
    }
  },
  methods: {
    format_journal_artwork(j) {
      if (j.class_name == 'Artwork') {
        var a = this.$store.state.artworks.find((a) => a.id == j.journaled_id)
        // var u = this.$store.state.users.find(u => u.id == j.user_id)
        // console.log(a)
        if (a) {
          return `${j.class_name}:<b> ${a.title}</b>, ${a.full_name}`
        } else {
          return ''
        }
      } else if (j.class_name == 'ArtworkLocation') {
        var a = this.$store.state.locations.find((a) => a.id == j.journaled_id)
        return `Artwork Location: ${a ? a.name : 'DELETED'}`
      }
    },
    format_journal_journal(j) {
      // var a = this.$store.state.artworks.find(a => a.id == j.journaled_id)
      // var u = this.$store.state.users.find(u => u.id == j.user_id)
      return `"${j.value_name}" changed from "${j.old_value}" to "${j.new_value}`
    },
    format_journal_user(j) {
      // var a = this.$store.state.artworks.find(a => a.id == j.journaled_id)
      if (j.user_id) {
        var u = this.$store.state.users.find((u) => u.id == j.user_id)
        return `${u.firstname} ${u.lastname}`
      } else {
        return 'unknown'
      }
    },
    format_date(date) {
      var moment = require('moment')
      var ndate = new Date(date)
      return moment(ndate).format('YYYY-MM-DD hh:mm')
    },
    exhibitionsInYear(y) {
      return this.$store.getters.exhibitions.filter(
        (e) => y == e.duration_start_year || y == e.duration_end_year
      )
    },
    loansInYear(y) {
      return this.$store.getters.loans.filter(
        (e) => y == e.duration_start_year || y == e.duration_end_year
      )
    },
    artworksInYear(y) {
      // console.log(this.$store.state.artworks[2].production_date_new.substring(0,4))
      return this.$store.state.artworks.filter(
        (e) =>
          y >=
          (e.production_date_new != null
            ? e.production_date_new
            : '    '
          ).substring(0, 4)
      )
    },
  },
  computed: {
    years() {
      var end = 2020
      var start = 2000
      return Array(end - start + 1)
        .fill()
        .map((_, idx) => start + idx)
      // return [2019,2018,2017,2016,2015,2014,2013,2001]
    },
    labels() {
      return this.years.map((y) => {
        return `${y} (${this.exhibitionsInYear(y).length})`
      })
    },
    value_exhibitions() {
      return this.years.map((y) => {
        return this.exhibitionsInYear(y).length
      })
    },
    value_loans() {
      return this.years.map((y) => {
        return this.loansInYear(y).length
      })
    },
    years_artworks() {
      var end = 2020
      var start = 1950
      return Array(end - start + 1)
        .fill()
        .map((_, idx) => start + idx)
    },
    // labels_artworks () {
    //   return this.years.map(y => { return `${y} (${this.exhibitionsInYear(y).length})` })
    // },
    value_artworks() {
      return this.years_artworks.map((y) => {
        return this.artworksInYear(y).length
      })
    },
    // c_user  () {
    //   return this.$store.state.user.profile
    // },
    journals() {
      if (this.myJournal) {
        return this.journals_store.filter((j) => j.user_id === this.c_user.id)
      } else {
        return this.journals_store
      }
    },
    support_articles() {
      return this.sa_store.filter((sa) => sa.updates == 1)
    },
  },
}
</script>

<style scoped>
.value {
  width: 80px !important;
  display: inline-block;
  text-align: right;
  margin-right: 10px;
}
.underline {
  color: #777;
}
.menu:hover {
  color: black;
}
.atWork {
  background-color: mintcream;
}
</style>


// WEBPACK FOOTER //
// src/components/layout/Facts.vue